// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .importQuestionModal {
    max-width: 64.375rem !important;
}

.importQuestionModal .table > tbody > tr > td {
    word-wrap: break-word;
} 


.importQuestionModal-toyota .modal-dialog, .importQuestionModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.importQuestionModal-lexus .modal-dialog, .importQuestionModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.importQuestionModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.importQuestionModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}

.importQuestionModal .css-10nd86i {
    width: 50%;
}

.importQuestionModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.importQuestionModal-lexus .css-10nd86i svg {
    color: #252525;
}

.importQuestionModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.importQuestionModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.importQuestionModal tbody {
    overflow-y: scroll;
    border: solid 1px #a8aaac;
    height: 30rem !important;
    display: block;
    width: 63rem;
}

.importQuestionModal .table > tbody > tr > td.react-bs-table-no-data {
    width: 79rem !important;
} 
`, "",{"version":3,"sources":["webpack://./src/components/questionnaire/components/index.css"],"names":[],"mappings":"CAAC;IACG,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[" .importQuestionModal {\n    max-width: 64.375rem !important;\n}\n\n.importQuestionModal .table > tbody > tr > td {\n    word-wrap: break-word;\n} \n\n\n.importQuestionModal-toyota .modal-dialog, .importQuestionModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.importQuestionModal-lexus .modal-dialog, .importQuestionModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.importQuestionModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.importQuestionModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n.importQuestionModal .css-10nd86i {\n    width: 50%;\n}\n\n.importQuestionModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.importQuestionModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.importQuestionModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.importQuestionModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.importQuestionModal tbody {\n    overflow-y: scroll;\n    border: solid 1px #a8aaac;\n    height: 30rem !important;\n    display: block;\n    width: 63rem;\n}\n\n.importQuestionModal .table > tbody > tr > td.react-bs-table-no-data {\n    width: 79rem !important;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
